import { useParams } from 'react-router-dom'
import { NewConvenienceLocationPage } from '../new-company-pages/NewConvenienceLocationPage'

export default function ConvenienceDoorPage() {
  const urlParams = useParams()
  const convenienceID = parseInt(urlParams.convenience_id!)

  return <NewConvenienceLocationPage convenienceID={convenienceID} />
}
